import { useState } from "react";
import { useTitle } from "../../hooks/useTitle";
import { UploadFrjTagFilterForm } from "../../patterns/UploadFrjTagFilterForm";

export const FrjTagsFilterAdmin = () => {
  useTitle("FRJ Tags Filter | Compass");

  const [message, setMessage] = useState<string>("");

  return (
    <div style={{ padding: "1rem" }}>
      <h2>FRJ Tag Filter</h2>
      <p style={{ color: "#555", marginBottom: "1rem" }}>
        Upload a CSV with an <code>Entries</code> column containing the tag
        names to display on the FRJ tags page. If no filter is uploaded, all
        tags are shown.
      </p>
      <UploadFrjTagFilterForm
        onSubmit={(msg: string) => {
          setMessage(msg);
        }}
      />
      {message && (
        <div
          style={{
            marginTop: "1rem",
            padding: "1rem",
            backgroundColor: "#d4edda",
            color: "#155724",
            borderRadius: "0.25rem",
          }}
        >
          {message}
        </div>
      )}
    </div>
  );
};
